module.exports = __webpack_public_path__ + "img/thumb_15.80659010.jpg";